import { CourierFormFields } from '../../../components/courier-form-fields.component';
import { CourierFormModal } from '../../../components/courier-form-modal.component';
import { EditCourierActionProps, useEditCourierAction } from './edit-courier-action.hook';

export function EditCourierModal(props: EditCourierActionProps) {
  const { state, handlers, control, handleSubmit, formConfig, activeLoginTab, setActiveLoginTab } =
    useEditCourierAction(props);

  return (
    <CourierFormModal
      title={`Edit ${props.courier.displayName || 'courier'}`}
      saving={state.saving}
      error={state.error}
      onCancel={handlers.onCancel}
      onSubmit={handleSubmit(handlers.onSubmit)}
    >
      {/* No carrier pickers — moving a courier to another carrier is its own operation — and no
          notes field, which belongs to creating a courier rather than to their details. */}
      <CourierFormFields
        control={control}
        projectID={props.projectID}
        formConfig={formConfig}
        activeLoginTab={activeLoginTab}
        setActiveLoginTab={setActiveLoginTab}
      />
    </CourierFormModal>
  );
}
